import { AxiosError } from 'axios'
import { ZodError } from 'zod'

import { STATUS_CODES } from '@/constants/statusCodes'

import getResponseErrorMessage from '../getResponseErrorMessage'
import getResponseStatusCode from '../getResponseStatusCode'

const formatResponseError = (_error: unknown) => {
  const error = _error as ZodError | AxiosError
  if (error instanceof ZodError) {
    return {
      status: STATUS_CODES.INTERNAL_SERVER_ERROR,
      message: error.issues
    }
  }
  if (error instanceof AxiosError) {
    return {
      status: getResponseStatusCode(error) || STATUS_CODES.INTERNAL_SERVER_ERROR,
      message: getResponseErrorMessage(error)
    }
  }
  return {
    status: STATUS_CODES.INTERNAL_SERVER_ERROR,
    message: getResponseErrorMessage(error)
  }
}

export default formatResponseError
